import {
    DataTableCell,
    ITableColumn,
    ProviderMissingEvidence,
    GetProviderEvidenceMissingListSortEnum,
} from '@enter/core';

const formatProviderName = (provider?: ProviderMissingEvidence['billingProvider']): string => {
    if (!provider) {
        return '';
    }

    if (provider.organization) {
        return provider.organization;
    }

    const parts = [provider.first, provider.last].filter(Boolean);
    return parts.join(' ');
};

const formatRenderingProvider = (provider?: ProviderMissingEvidence['renderingProvider']): string => {
    if (!provider) {
        return '';
    }

    const parts = [provider.first, provider.last].filter(Boolean);
    if (parts.length > 0) {
        return parts.join(' ');
    }

    return provider.organization || '';
};

export const missingEvidenceColumns: ITableColumn<ProviderMissingEvidence, GetProviderEvidenceMissingListSortEnum>[] = [
    {
        id: 'EvidenceType',
        Header: 'Evidence Type',
        accessor: (row): string => row.evidenceType?.name || '',
        Cell: DataTableCell('String'),
        sortType: GetProviderEvidenceMissingListSortEnum.EVIDENCETYPEID,
    },
    {
        id: 'Description',
        Header: 'Description',
        accessor: (row): string => row.evidenceType?.description || '',
        Cell: DataTableCell('String'),
        disableSortBy: true,
    },
    {
        id: 'FromDateOfService',
        Header: 'From Date',
        accessor: (row): string => row.fromDateOfService || '',
        Cell: DataTableCell('Date'),
        disableSortBy: true,
    },
    {
        id: 'ThroughDateOfService',
        Header: 'Through Date',
        accessor: (row): string => row.throughDateOfService || '',
        Cell: DataTableCell('Date'),
        disableSortBy: true,
    },
    {
        id: 'PrimaryPayer',
        Header: 'Primary Payer',
        accessor: (row): string => row.primaryPayer?.name || '',
        Cell: DataTableCell('String'),
        disableSortBy: true,
    },
    {
        id: 'BillingProvider',
        Header: 'Billing Provider',
        accessor: (row): string => formatProviderName(row.billingProvider),
        Cell: DataTableCell('String'),
        disableSortBy: true,
    },
    {
        id: 'RenderingProvider',
        Header: 'Rendering Provider',
        accessor: (row): string => formatRenderingProvider(row.renderingProvider),
        Cell: DataTableCell('String'),
        disableSortBy: true,
    },
    {
        id: 'Facility',
        Header: 'Facility',
        accessor: (row): string => row.facility?.name || '',
        Cell: DataTableCell('String'),
        disableSortBy: true,
    },
    {
        id: 'RequiredToStartExperiment',
        Header: 'Required to Start',
        accessor: (row): string => row.evidenceType?.requiredToStartExperiment ? 'Yes' : 'No',
        Cell: DataTableCell('String'),
        disableSortBy: true,
    },
];

